/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class TreeValue {
        public value: any;
        public type: Wars.Domain.Model.Codes.Enums.VariableType;
    }
}